export default __webpack_public_path__ + "static/apple-icon-114x114-3c42da5eb025c51dbcf71c9519b2fa8e.png";